import getNavigatorLocale from "FlowBuilder/lib/localeHelper"

const useCurrency = () => {
  const [currency, setCurrency] = useState('GBP')
  const [currencySymbol, setCurrencySymbol] = useState('£')

  useEffect(() => {
    try {
      const locale = getNavigatorLocale()
      let region = locale.split('-')[1]?.toUpperCase()
      
      // Handle language-only locales by mapping to most common country
      if (!region) {
        const langToRegion = {
          SV: 'SE', // Swedish -> Sweden
          DA: 'DK', // Danish -> Denmark
          NB: 'NO', // Norwegian -> Norway
          NO: 'NO', // Norwegian -> Norway
          FI: 'FI', // Finnish -> Finland
          PL: 'PL', // Polish -> Poland
          CZ: 'CZ', // Czech -> Czech Republic
          DE: 'DE', // German -> Germany
          FR: 'FR', // French -> France
          NL: 'NL'  // Dutch -> Netherlands
        }
        region = langToRegion[locale.toUpperCase()] || 'GB'
      }
      
      const regionToCurrency = {
        US: 'USD', GB: 'GBP', DE: 'EUR', FR: 'EUR', AU: 'AUD',
        CA: 'CAD', CH: 'CHF', SE: 'SEK', NO: 'NOK', DK: 'DKK',
        PL: 'PLN', CZ: 'CZK', AT: 'EUR', BE: 'EUR', FI: 'EUR',
        NL: 'EUR', PT: 'EUR', IE: 'EUR', NZ: 'NZD'
      }
      
      const detectedCurrency = regionToCurrency[region] || 'GBP'
      const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: detectedCurrency,
        currencyDisplay: 'narrowSymbol'
      })
      
      const parts = formatter.formatToParts(0)
      const symbol = parts.find(p => p.type === 'currency')?.value || '£'
      
      setCurrency(detectedCurrency)
      setCurrencySymbol(symbol)
    } catch {
      // Keep defaults
    }
  }, [])

  return { currency, currencySymbol }
}

export default useCurrency
